module.exports = __webpack_public_path__ + "static/media/tealium-ie-manager.9bc43bb2.md";